import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import {
	XSpace,
	XDropdown,
	XAvatar,
	XDownOutlined,
	XSpaceNotif,
	Breadcrumb,
	XBreadcrumb,
	XUpdateModal,
	XHeaderContainer,
	HeaderTitle,
	XThemeDateDays,
} from '../../components/Header/HeaderStyle';
import {
	XContainer,
	XThemeContainer,
	XThemeFormsTitle,
	XThemeMobilePoliciesCodes,
} from '../../styles/GlobalThemeStyle';
// actions
import { logoutApi, logoutReset } from '../../actions/logoutAction';
import { Col, Row, Space, notification, Avatar, Spin, Skeleton } from 'antd';
import config from '../../config';
import { checkModulePermissions, getUserProfile } from '../../utils/helper';
import { SoundOutlined } from '@ant-design/icons';
// Todo Notification Commented for Demo Branch
import NotificationPopover from '../Notification/NotificationsPopover';
import moment from 'moment';
import {
	getCodeUpdateDatesApi,
	getCodeUpdateDatesReset,
} from '../../actions/getCodeUpdateDatesAction';
import Header from '../Header/Header';
import HeaderFile from '../Header/HeaderFile';

const PoliciesCodes = (props) => {
	const {
		// logout,
		// logoutReset,
		// logoutState,
		getCodeUpdateDates,
		getCodeUpdateDatesState,
		getCodeUpdateDatesReset,
	} = props;
	const navigate = useNavigate();
	const [updatedDatesModal, setUpdatedDatesModal] = useState(false);
	const [datesLoading, setDatesLoading] = useState(false);
	const [updatedDates, setUpdatedDates] = useState('');

	const formatDate = (date) => {
		const options = {
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		};
		return date.toLocaleDateString('en-US', options);
	};

	const today = new Date();

	useEffect(() => {
		if (getCodeUpdateDatesState.apiState === 'loading') {
			setDatesLoading(true);
		}
		if (getCodeUpdateDatesState.apiState === 'success') {
			setDatesLoading(false);
			setUpdatedDates(getCodeUpdateDatesState.data);
		}
		if (getCodeUpdateDatesState.apiState === 'error') {
			setDatesLoading(false);
			notification.error({ message: getCodeUpdateDatesState.message });
		}
		getCodeUpdateDatesReset();
	}, [getCodeUpdateDatesState]);

	useEffect(() => {
		setUpdatedDates();
		getCodeUpdateDates();
	}, []);

	return (
		<>
			{props.displayHeader ? (
				<></>
			) : (
				<>
					<Col lg={24} xl={24} xs={0} md={0}>
						<Header headerTag="Policies and Codes Updated at" />
					</Col>
					<Col lg={0} xl={0} xs={24} md={24}>
						<HeaderFile headerTag="caseAnalysis" />
					</Col>
				</>
			)}
			<XThemeContainer fluid>
				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<XThemeFormsTitle>
							Policies and Codes Updated at
						</XThemeFormsTitle>
					</Col>
					{datesLoading && (
						<Col span={24} style={{ textAlign: 'center' }}>
							<Skeleton active paragraph={{ rows: 3 }} />
						</Col>
					)}
					{updatedDates &&
						updatedDates.map((item) => (
							<>
								<Col
									xs={24}
									sm={12}
									md={12}
									lg={12}
									className="my-2"
									key={item._id}
								>
									<XThemeMobilePoliciesCodes
										title={
											<Space>
												<div className="cardImgBg">
													<img
														src="/images/policies-ncd-icon.svg"
														alt=""
													/>
												</div>
												<h4
													style={{
														color: '#212226',
														fontWeight: '600',
													}}
												>
													{item.code_type}
												</h4>
											</Space>
										}
									>
										<Row
											gutter={(15, 15)}
											className="align-items-center"
										>
											<Col xs={18}>
												<h6>
													{(item.code_type ===
														'ICD' &&
														item.update_name) ||
													(item.code_type === 'CPT' &&
														item.update_name) ? (
														<>
															Version -{' '}
															{item.update_name}
														</>
													) : (
														<>
															Released On -{' '}
															{moment(
																item
																	.latest_update
																	.date,
															).format(
																'DD MMM YYYY',
															)}
														</>
													)}
												</h6>
												<h6 style={{ fontStyle: '' }}>
													Last Checked Date -{' '}
													{moment(
														item.updatedAt,
													).format('DD MMM YYYY')}
												</h6>
											</Col>
										</Row>
									</XThemeMobilePoliciesCodes>
								</Col>
							</>
						))}
				</Row>
			</XThemeContainer>
		</>
	);
};

const mapStateToProps = (state) => ({
	logoutState: state.logout,
	getCodeUpdateDatesState: state.getCodeUpdateDates,
});

const mapDispatchToProps = (dispatch) => ({
	logout: (params) => dispatch(logoutApi(params)),
	logoutReset: () => dispatch(logoutReset()),
	getCodeUpdateDates: () => dispatch(getCodeUpdateDatesApi()),
	getCodeUpdateDatesReset: () => dispatch(getCodeUpdateDatesReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PoliciesCodes);
